import { render, staticRenderFns } from "./DokmanComponentLenkungInhalt.vue?vue&type=template&id=2d07d168&scoped=true"
import script from "./DokmanComponentLenkungInhalt.vue?vue&type=script&lang=js"
export * from "./DokmanComponentLenkungInhalt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d07d168",
  null
  
)

export default component.exports